













import Vue from 'vue'

export default Vue.extend({
  props: {
    align: {
      type: String,
      default: 'right',
    },
    stairWidth: {
      type: Number,
      default: 7,
    },
    stairCount: {
      type: Number,
      default: 11,
    },
    horizontal: {
      type: Boolean,
      default: true,
    },
    topLeftCorner: {
      type: Boolean,
      default: false,
    },
    topRightCorner: {
      type: Boolean,
      default: false,
    },
    bottomRightCorner: {
      type: Boolean,
      default: false,
    },
    bottomLeftCorner: {
      type: Boolean,
      default: false,
    },
    boundingBoxHorizontalHeight: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    cssVars() {
      return {
        '--stair-width': this.stairWidth + 'px',
        '--landing-right-width': (this.stairCount > 7 ? 29 : 15) + 'px',
        '--landing-left-width': (this.stairCount > 7 ? 18 : 13) + 'px',
        '--right': this.align == 'right' ? 0 : 'auto',

        // '--width': this.width + 'px',
      }
    },

    boundingBoxCssVars() {
      return {
        '--bounding-box-horizontal-height': this.boundingBoxHorizontalHeight + 'px',
      }
    },

    cornerClass: function() {
      if (this.topLeftCorner) return 'rounded-tl-xl' //'Corner-Top-Left'
      if (this.topRightCorner) return 'rounded-tr-xl'
      if (this.bottomRightCorner) return 'rounded-br-xl'
      if (this.bottomLeftCorner) return 'rounded-bl-xl'
      return ''
    },
  },
})
